module.exports = __webpack_public_path__ + "img/202411_01_sp.f26d78f5.jpg";